import { Injectable } from '@angular/core';
import { CommunicationConfigService } from '@argalis-apps/angular-global';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MFormation } from '@argalis-apps/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormationService {
  constructor(private communicationConfigService: CommunicationConfigService, private http: HttpClient) {}

  getListFormationByClient(idclient: string): Observable<MFormation.IFormationInfo[]> {
    let params = new HttpParams();
    params = params.set('id_client', idclient);
    return this.http.get<MFormation.IFormationInfo[]>(
      `${this.communicationConfigService.getApiUri()}/formation/formation-list`,
      {
        params
      }
    );
  }
  getFormationInfo(idSession: number, isParcours = false): Observable<any> {
    let params = new HttpParams();
    params = params.set('isParcours', isParcours.toString());
    return this.http.get<any>(`${this.communicationConfigService.getApiUri()}/formation/formation-info/${idSession}`, {
      params
    });
  }
  getDocment(idSession: string, table: string, idSessionClient = null, idIntervenant = 0, bVrac = false): Observable<any> {
    let params = new HttpParams();
    params = params.set('idIntervenant', idIntervenant.toString());
    return this.http.get<any>(
      `${this.communicationConfigService.getApiUri()}/formation/document-gestion/${idSession}/${table}/${idSessionClient}/${bVrac}`, {params}
    );
  }
  getDocmentVrac(idSession: string, table: string, idSessionClient = null): Observable<any> {
    return this.http.get<any>(
      `${this.communicationConfigService.getApiUri()}/formation/document-gestion/${idSession}/${table}/${idSessionClient}/${true}`
    );
  }

  getDocumentsZip(files) {
    const data = this.http.post<any>(
      `${this.communicationConfigService.getApiUri()}/formation/document-gestion/download-zip`,
      { files }
    );

    return data;
  }

  // getDownloadDocument(idSession: string,) {
  //   return this.http.get<any>(`${this.communicationConfigService.getApiUri()}/formation/document/${formId}/${moda}`
  // }
}
